<script>
  import auth from 'services/auth/authService'
  import Loader from '../../../shared/feedback/Loader/Loader.svelte'
  import { onMount } from 'svelte'
  import { isAuthenticated, user } from 'stores/auth'
  import { getUserRoles } from 'services/api/apiCalls'
  import { startWebSocketSession } from 'services/api/apiCalls'
  import { handleWebSocketMessage, connectToWebSocket } from '../../../services/websocket/websocket'
  /**
   * @typedef {Object} Props
   * @property {import('svelte').Snippet} [children]
   */

  /** @type {Props} */
  let { children } = $props()

  let auth0Client

  function getCurrentRelativeUrl() {
    const { pathname, search, hash } = window.location
    return `${pathname}${search}${hash}`
  }

  function getSafeReturnTo(appState) {
    const returnTo = appState?.returnTo

    if (typeof returnTo !== 'string') {
      return '/'
    }

    if (!returnTo.startsWith('/') || returnTo.startsWith('//')) {
      return '/'
    }

    return returnTo
  }

  async function getRoles() {
    await getUserRoles()
  }

  async function setupWebSocket() {
    console.log('Setting up WebSocket connection...')
    startWebSocketSession().then(() => {
      connectToWebSocket(handleWebSocketMessage)
    })
  }

  onMount(async () => {
    auth0Client = await auth.createClient()
    const authenticated = await auth0Client.isAuthenticated()

    if (authenticated) {
      user.set(await auth0Client.getUser())
      getRoles()
      isAuthenticated.set(true)
      setupWebSocket()
    } else {
      if (window.location.pathname == '/callback') {
        await auth0Client.handleRedirectCallback().then(result => {
          window.location.href = getSafeReturnTo(result?.appState)
        })
      } else {
        auth0Client.loginWithRedirect({
          appState: {
            returnTo: getCurrentRelativeUrl(),
          },
        })
      }
    }
  })
</script>

{#if $isAuthenticated}
  {@render children?.()}
{:else}
  <Loader fullScreen={true} />
{/if}
